import { Heart, Phone, Mail, MapPin } from "lucide-react";
import logoImage from '../assets/logo.png';

export function Footer() {
  return (
    <footer className="bg-fun-navy text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          <div>
            <div className="mb-4">
              <img 
                src={logoImage} 
                alt="Fun 'n Sun Mobile Home & RV Park Logo" 
                className="h-20 w-auto brightness-0 invert"
              />
            </div>
            <p className="text-sm opacity-90 leading-relaxed mb-2">
              Your perfect desert oasis in the heart of Overton, Nevada. 
              A 55+ community designed for comfort and connection.
            </p>
            <p className="text-fun-blue font-medium italic">
              "Where the summer sun spends the winter"
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-fun-yellow">Quick Contact</h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-fun-blue" />
                <span>(702) 397-8894</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-fun-blue" />
                <span>fun_n_sun@mvdsl.com</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-fun-blue" />
                <span>Overton, Nevada</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-fun-yellow">Season Information</h4>
            <div className="text-sm space-y-2">
              <p><strong className="text-fun-teal">55+ Season:</strong> October - May</p>
              <p><strong className="text-fun-teal">Summer Season:</strong> June - September</p>
              <p className="opacity-80 text-xs mt-3">
                All guests subject to Park rules and Management approval
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center">
          <p className="text-sm opacity-80 flex items-center justify-center gap-2">
            Made with <Heart className="h-4 w-4 text-primary" /> for the Fun 'n Sun community
          </p>
          <p className="text-xs opacity-60 mt-2">
            © 2025 Fun 'n Sun Mobile Home & RV Park. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}